import { useContext } from 'react';
import { useIntl } from 'react-intl';
import LocalizationContext from "../LocalizationProvider/LocalizationContext";
export var createFormattedNumber = function createFormattedNumber(number, locale, options) {
  return number.toLocaleString(locale, options);
};
export var useFormattedNumber = function useFormattedNumber(number, options) {
  var _useContext = useContext(LocalizationContext),
      preferences = _useContext.preferences;

  var parentIntl = useIntl();
  var locale = (preferences === null || preferences === void 0 ? void 0 : preferences.locale) || parentIntl.locale;
  return createFormattedNumber(number, locale, options);
};